/**
 * Created by lenovo on 2017/4/21.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
const returnJson =(map) =>{
    const json = [];
    for(var key in map)
    {
        const arr = {"id":key,"name":map[key]};
        json.push(arr);
    }
    const data = json.map(function (str,index) {
        return <option value={str.id} key={index}>{str.name}</option>
    });
    return data;
};
import {language,getUserId,resultTip} from 'UTIL/common'
export default class FormSelect extends Component{
    render(){
        const options = returnJson(this.props.data);
        return (
            <div className="row form-group">
                <label  className="multi-label control-label col-xs-2">{language()[this.props.name]}</label>
                <div className="col-xs-3">
                    <select  className="form-control" id={this.props.id}>
                        <option value=''>{language()['pleaseSelect']}</option>
                        {options}
                    </select>
                </div>
                <span className = "">
                      <span id={"error_"+this.props.id}  name="success" ></span>
                      <span className = ""></span>
                </span>
                <p className="form-control-static text-danger">
                    <span style={{fontSize: "20px"}}>*</span>
                </p>
            </div>
        )
    }
}
//<FormSelect id="" name="" data="" />传入的data值是map类型


// WEBPACK FOOTER //
// ./modules/component/form/formSelect.js